<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs4>
                <h1>Archived Tasks</h1>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    @input="updateRows"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs8 class="text-right">
                <v-btn color="primary" dark @click="createJobTaskCallback()">Add Task</v-btn>
                <v-btn color="primary" class="ml-2" outlined dark :to="'/management/tasks/active'">Active</v-btn>
                <v-btn color="green ml-2" dark :to="'/management/tasks/completed'">Completed</v-btn>
                <v-btn color="orange ml-2" dark :to="'/management/tasks/delayed'">Delayed</v-btn>
                <v-btn color="purple ml-2" dark :to="'/management/tasks/inprogress'">In Progress</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="displayTasks"
                        item-key="name"
                        :server-items-length="numDisplayTasks"
                        :options.sync="options"
                        class="elevation-1 task-table">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="blue"
                                        @click="handleDetails(item)">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Task Details</span>
                            </v-tooltip>
                            <v-tooltip top v-if="item.jobTask.archived">
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="green"
                                        @click="restoreDialogForJobTask(item)">
                                        mdi-restore
                                    </v-icon>
                                </template>
                                <span>Restore Task</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="red"
                                        @click="deleteDialogForJobTask(item)">
                                        delete_forever
                                    </v-icon>
                                </template>
                                <span>Delete Task</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <add-jobTask
            :showDialog="createJobTaskDialog"
            :toggle="toggleCreate">
        </add-jobTask>
        <restore-jobTask
            :showDialog="restoreJobTaskDialog"
            :toggle="toggleRestore"
            :jobTask="jobTaskToRestore">
        </restore-jobTask>
        <delete-jobTask
            :showDialog="deleteJobTaskDialog"
            :toggle="toggleDelete"
            :jobTask="jobTaskToDelete">
        </delete-jobTask>
        <jobTask-details
            :showDialog="detailsJobTaskModal"
            :toggle="toggleDetails"
            :jobTask="jobTaskForDetails">
        </jobTask-details>

    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Helpers from  '@/utils/helpers/jobTaskHelpers'
    import AddJobTask from '@/components/jobTasks/Add'
    import RestoreJobTask from '@/components/jobTasks/Restore'
    import DeleteJobTask from '@/components/jobTasks/Delete'
    import JobTaskDetails from '@/components/jobTasks/Details'


    export default {
        name: 'ArchivedTasks',
        components: {
            AddJobTask,
            RestoreJobTask,
            DeleteJobTask,
            JobTaskDetails
        },
        created () {
            this.getJobTaskRange({keywords: '', limit: 10, offset: 0})
            //this.loadDelayedJobTasks()
        },
        data () {
            return {
                restoreJobTaskDialog: false,
                createJobTaskDialog: false,
                deleteJobTaskDialog: false,
                detailsJobTaskModal: false,
                index: null,
                jobTaskToRestore: {},
                jobTaskToDelete: {},
                jobTaskForDetails: {},
                search: '',

                options: {},
                displayTasks: [],
                numDisplayTasks: 0,
            }
        },

        methods: {
            ...mapActions({
                getJobTaskRange: 'jobTasks/getArchivedRange',
                getArchivedCount: 'jobTasks/getArchivedCount',
                getTask: 'jobTasks/getById'
            }),

            toggleCreate() {
                if(this.createTaskDialog){
                    this.updateRows()
                }
                this.createJobTaskDialog = !(this.createJobTaskDialog)
            },
            toggleRestore() {
                if(this.restoreJobTaskDialog){
                    this.updateRows()
                }
                this.restoreJobTaskDialog = !(this.restoreJobTaskDialog)
            },
            toggleDelete() {
                if(this.deleteJobTaskDialog){
                    this.updateRows()
                }
                this.deleteJobTaskDialog = !(this.deleteJobTaskDialog)
            },
            toggleDetails() {
                if(this.detailsJobTaskModal){
                    this.updateRows()
                }
                this.detailsJobTaskModal = !(this.detailsJobTaskModal)
            },
            handleDetails(item) {
                this.jobTaskForDetails = item.jobTask
                this.getTask(item.jobTask.id)
                this.toggleDetails()
            },
            restoreDialogForJobTask(item) {
                this.jobTaskToRestore = item.jobTask
                this.toggleRestore()
            },
            deleteDialogForJobTask(item) {
                this.jobTaskToDelete = item.jobTask
                this.toggleDelete()
            },
            createJobTaskCallback() {
                this.toggleCreate()
            },
            updateRows(){
                let limit = this.options.itemsPerPage
                let offset = this.options.itemsPerPage * (this.options.page - 1)
                //picking 'all' sets limit to -1 so we can handle that here
                if(limit < 0){
                    limit = this.archivedCount
                    offset = 0
                }
                this.getArchivedCount()
                this.getJobTaskRange({keywords: this.search, limit: limit, offset: offset})
            }
        },

        computed: {
            ...mapGetters({
                headers: 'jobTasks/headers',
                error: 'jobTasks/error',
                jobTaskRange: 'jobTasks/archivedTaskRange',
                archivedCount: 'jobTasks/archivedCount',
            }),
        },
        watch: {
            options: {
                handler () {
                    this.updateRows()
                },
                deep: true,
            },
            jobTaskRange: {
                handler() {
                    this.displayTasks = Helpers.display(this.jobTaskRange)
                    this.numDisplayTasks = this.archivedCount
                },
                deep: true
            },
            archivedCount: function (){
                this.numDisplayTasks = this.archivedCount
            }
        },

    }
</script>

<style>
    .task-table{
        table-layout : fixed;
    }
</style>
